export default __webpack_public_path__ + "static/media/attract.c08be395.png";